module.exports = __webpack_public_path__ + "static/img/ph-max-banner-ar.74eb9e4c.jpg";